import React from 'react';
import { motion } from 'framer-motion';

const skillCategories = [
  {
    title: "Frontend Skills",
    skills: [
      { name: "React.js", level: "90%" },
      { name: "Next.js", level: "90%" },
      { name: "HTML/CSS", level: "90%" },
      { name: "Tailwind / MUI", level: "90%" },
      { name: "Library & Framework Adaptability", level: "80%" },
    ],
  },
  {
    title: "Backend Skills",
    skills: [
      { name: "Node.js", level: "90%" },
      { name: "Firebase", level: "90%" },
      { name: "Supabase", level: "80%" },
      { name: "MongoDb", level: "85%" },
      { name: "Web Scraping", level: "90%" },
    ],
  },
];

const Skills = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      {skillCategories.map((category, index) => (
        <div key={index} className="w-full lgl:w-1/2">
          <div className="py-12 font-titleFont flex flex-col gap-4">
            <p className="text-sm font-semibold dark:text-designColor text-blue-600 tracking-[4px] uppercase">
              Features
            </p>
            <h2 className="text-3xl md:text-4xl font-bold">{category.title}</h2>
          </div>
          <div className="flex flex-col gap-6">
            {category.skills.map((skill, skillIndex) => (
              <div key={skillIndex} className="overflow-x-hidden">
                <p className="text-sm uppercase font-medium">{skill.name}</p>
                <span className="w-full h-2 bg-gray-300 rounded-md inline-flex mt-2">
                  <motion.span
                    initial={{ x: "-100%", opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.5 }}
                    style={{width: skill.level}}
                    className={`h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative`}
                  >
                    <span className="absolute text-gray-600 dark:text-gray-300 font-semibold -top-7 right-0">{skill.level}</span>
                  </motion.span>
                </span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </motion.div>
  );
};

export default Skills;